import { render, staticRenderFns } from "./UserHelpArticleCard.vue?vue&type=template&id=69f77de9&scoped=true&functional=true&"
import script from "./UserHelpArticleCard.vue?vue&type=script&lang=ts&"
export * from "./UserHelpArticleCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpArticleCard.vue?vue&type=style&index=0&id=69f77de9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "69f77de9",
  null
  
)

export default component.exports